import React from 'react';
import SendImg from './assets/send.svg';
import styles from './style.css';

/**
 * Password input component for authentication
 */
export const PasswordInput = ({ t, inputMessage, setInputMessage, isResponding, onSend }) => (
    <div className={styles.chatbox}>
        <div className={styles.loginBox}>
            <p>{t("password_required")}</p>

            <div className={styles.row}>
                <input
                    type="password"
                    autoComplete="off"
                    placeholder={t("password")}
                    className={styles.input}
                    value={inputMessage}
                    onChange={(e) => setInputMessage(e.target.value)}
                    onKeyDown={(key) => key.key == 'Enter' ? onSend() : null}
                    disabled={isResponding}
                />

                <button onClick={onSend} className={[styles.sideButton, styles.sideButtonLower].join(" ")}>
                    <img className={styles.img} src={SendImg} alt="Send" />
                </button>
            </div>

            <p>{t("access_request")}</p>
        </div>
    </div>
);

/**
 * Nickname input component
 */
export const NicknameInput = ({ t, inputMessage, setInputMessage, isResponding, onSend }) => (
    <div className={styles.chatbox}>
        <div className={styles.loginBox}>
            <p>{t("nickname_required")}</p>

            <div className={styles.row}>
                <input
                    type="text"
                    autoComplete="off"
                    placeholder={t("nickname")}
                    className={[styles.input, styles.nickname].join(" ")}
                    value={inputMessage}
                    onChange={(e) => setInputMessage(e.target.value)}
                    onKeyDown={(key) => key.key == 'Enter' ? onSend() : null}
                    disabled={isResponding}
                />

                <button onClick={onSend} className={[styles.sideButton, styles.sideButtonLower].join(" ")}>
                    <img className={styles.img} src={SendImg} alt="Send" />
                </button>
            </div>
        </div>
    </div>
);

/**
 * Legal (ToC) confirmation popup
 */
export const Legal = ({ t, setLegalVisible }) => {
    const confirmed = () => {
        console.log("User confirmed legal popup.")
        document.cookie = "legalConfirm=true; max-age=15552000; path=/; SameSite=Lax"
        setLegalVisible(false)
    }
    return (
        <div className={styles.chatbox}>
            <div className={styles.legal}>
                <p>Potvrzuji, že jsem se seznámil s&nbsp;<a href="/docs/podminky_uziti.pdf" target="_blank">Podmínkami užívání
                    služby Meow&nbsp;Coder</a> a&nbsp;s&nbsp;<a href="/docs/osobni_udaje.pdf" target="_blank">Informacemi o zpracování osobních údajů</a>.</p>
                <button onClick={confirmed}>OK</button>
            </div>
        </div>
    )
}